/**
 * Filter
 */
export const filter = {
  darkMode: `invert(1) hue-rotate(180deg)`,
};


